<template>
    <el-dialog class="dialog" :visible="dialogs.qualifications" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="loadItems">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Создать или найти ПК</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <local-preloader v-if="qualificationsLoader" />

            <div v-else class="dialog__content">
                <form class="search-form" @submit.prevent>
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="this.groupItemsBy.name === 'area_id' && createEntity">
                        <h3>Заполните новую ПК</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                          <div v-if="!this.kindId">
                            <div class="entity-form__inner" style="margin-bottom: 10px;">
                              <div class="entity-form__item entity-form__item_dot">
                                <span class="status-dot" :class="{'status-dot__danger': !this.selectedArea, 'status-dot__success': this.selectedArea}">
                                </span>
                              </div>
                              <div class="entity-form__item entity-form__item_select" style="width:100%;">
                                <v-select @input="selectArea" style="max-width: 100%;" class="select" placeholder="Выбрать ОПД для новой квалификации" name="level" label="name" v-model="selectedArea" :clearable="false" :options="this.areas">
                                  <template #search="{attributes, events}">
                                    <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        :required="!entityLevel"
                                    />
                                  </template>
                                  <template #no-options="{ search, searching, loading }">
                                    {{ SELECT_NOT_FOUND }}
                                  </template>
                                  <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                  </template>
                                </v-select>
                              </div>
                            </div>


                            <div class="entity-form__inner" v-if="!displayFormForKind" style="margin-bottom: 10px;">
                              <div class="entity-form__item entity-form__item_dot">
                                <span class="status-dot" :class="{'status-dot__danger': !this.selectedKind, 'status-dot__success': this.selectedKind}">
                                </span>
                              </div>
                              <div class="entity-form__item entity-form__item_select" style="max-width: 100%;flex-grow: 1;">
                                <v-select style="max-width: 100%;" class="select" placeholder="Выбрать ВПД для новой квалификации" name="level" label="name" v-model="selectedKind" :clearable="true" :options="this.kindsForSelectedArea">
                                  <template #search="{attributes, events}">
                                    <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        :required="!entityLevel"
                                    />
                                  </template>
                                  <template #no-options="{ search, searching, loading }">
                                    {{ SELECT_NOT_FOUND }}
                                  </template>
                                  <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                  </template>
                                </v-select>
                              </div>
                              <button :disabled="!Boolean(this.selectedArea)" @click="displayFormForKind = true" type="button" class="btn" style="margin-left: 15px;">
                                Создать новый ВПД
                              </button>
                            </div>

                            <Transition name="fade">
                              <div v-if="displayFormForKind" style="margin: 10px 0;">
                                <form class="entity-form" @submit.prevent="createNewKind">
                                  <div class="entity-form__inner">
                                    <div class="entity-form__item entity-form__item_dot">
                                      <span class="status-dot status-dot__warning">
                                      </span>
                                    </div>
                                    <div class="entity-form__item entity-form__item_code">
                                      <div class="input__inner">
                                        <masked-input
                                            name="code"
                                            class="input"
                                            :class="{'input_error': codeError}"
                                            v-model="newKind.code"
                                            placeholder="Код"
                                            :mask="{
                                                pattern: `\\${ String(this.selectedArea.code).padStart(2, 0) }.111`
                                            }"
                                        />
                                      </div>
                                    </div>
                                    <div class="entity-form__item entity-form__item_name">
                                      <validate-input v-model="newKind.name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                    </div>
                                    <div class="entity-form__item">
                                      <validate-input v-model="newKind.purpose" type="text" name="purpose" placeholder="Основная цель ВПД" :validateOptions="['empty']" />
                                    </div>
                                    <div class="entity-form__item entity-form__item_select">
                                      <v-select class="select" placeholder="Жизненный цикл" label="name" v-model="newKind.lifecycle_id" :clearable="false" :options="lifecycles" :reduce="(item) => item.id">
                                        <template #search="{attributes, events}">
                                          <input
                                              class="vs__search"
                                              :required="!newKind.lifecycle_id"
                                              v-bind="attributes"
                                              v-on="events"
                                          />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                          {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                      </v-select>
                                    </div>
                                    <div class="entity-form__item">
                                      <button type="submit" :disabled="!newKind.code || !newKind.name || !newKind.purpose || !newKind.lifecycle_id" class="btn btn_action">Создать</button>
                                    </div>
                                  </div>

                                  <div class="entity-form__inner" style="justify-content: end; margin-bottom: 15px;">
                                    <button type="button" @click="cancelKindCreation" style="margin: 6px 0 0 0; width:auto;color: #ce4556; background: transparent; text-align: center; display: inline-block; border:none; ">
                                      <span style="border-bottom: 1px dotted #ce4556;">Отменить создание ВПД</span>
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </Transition>


                            <div v-if="selectedKind && selectedKind.standard_id === null" style="margin: 10px 0;">

                              <div class="entity-form__inner" style="align-items: end;">
                                <div class="entity-form__item entity-form__item_dot" style="height: 4.8rem;">
                                      <span class="status-dot status-dot__warning">
                                      </span>
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                  <div style="color: #555555;margin-bottom: 5px;">
                                    Создайте профессиональный стандарт для выбранного ВПД:
                                  </div>
                                  <validate-input v-model="newStandard.name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название ПС" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item">
                                  <button type="button" @click="createNewStandard" class="btn btn_action">Создать ПС</button>
                                </div>
                              </div>
                            </div>

                          </div>

                            <div class="entity-form__inner">

                              <div class="entity-form__item">
                                <el-checkbox v-model="checkedEntity" />
                              </div>

                                <div class="entity-form__item entity-form__item_code" style="--code-width: 12rem;">
                                    <masked-input 
                                        name="code"
                                        class="input"
                                        placeholder="Код"
                                        :class="{'input_error': codeError}"
                                        v-model="code"
                                        :mask="{
                                            pattern: `11.11111.11`
                                        }"
                                    />
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item entity-form__item_select">
                                    <v-select class="select" placeholder="Уровень квалификации" name="level" label="value" v-model="entityLevel" :clearable="false" :options="qualificationLevels">
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                v-bind="attributes"
                                                v-on="events"
                                                :required="!entityLevel"
                                            />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="entity-form__item">
                                    <button :disabled="!code || !name || !entityLevel || (!this.kindId && !this.selectedKind)" type="submit" class="btn btn_action">Создать ПК</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    @sort-change="sortChange"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable="custom"
                        :min-width="15"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable="custom"
                        :min-width="85"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable="custom"
                        :min-width="15"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable="custom"
                        :min-width="85"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <el-pagination
                    background
                    class="mt-24"
                    layout="prev, pager, next"
                    :current-page="page"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="setPage"
                >
                </el-pagination>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" v-if="this.groupItemsBy.name === 'area_id'" :disabled="createEntity || qualificationsLoader" :title="kindId === null ? 'Создать новую ПК можно только внутри ВПД' : ''" @click="createEntity = true">
                            Создать новую ПК
                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="qualificationsLoader || selection.length === 0" @click="addItems">Добавить выбранные ПК</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import MaskedInput from 'vue-masked-input';

import constants from '@/constants.js';

import dialog from '@/mixins/dialog';
import LocalPreloader from '@/components/LocalPreloader'
import ValidateInput from '@/components/ValidateInput'

export default {
    props: {
        kindId: {
            type: Number,
            default: null,
        },
        qualificationsLoader: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ dialog ],
    components: {
        MaskedInput,
        LocalPreloader,
        ValidateInput
    },
    data() {
        return {
            selectedArea: null,
            kindsForSelectedArea: [],
            displayFormForKind: false,
            newKind: {},
            newStandard: {},
            selectedKind: null,
            checkedEntity: true,
            code: '',
            name: '',
            nameError: false,
            codeError: false,
            entityLevel: null,
            qualificationLevels: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        }
    },
    methods: {
        ...mapActions('editor', ['SAVE_QUALIFICATIONS', 'SAVE_KINDS_FROM_QUALIFICATIONS', 'LOAD_KINDS_BY_AREA', 'LOAD_KINDS', 'CREATE_STANDARD', 'LOAD_KIND_BY_ID']),
        ...mapActions('listsForEditor', ['CREATE_QUALIFICATION', 'CREATE_KIND']),
        ...mapMutations('editor', ['GROUP_QUALIFICATIONS']),


        closeDialog() {
            this.createEntity = false
            this.code = ''
            this.name = ''
            this.codeError = false
            this.nameError = false

            this.selection = []

            this.elDialogs.qualifications = false;
        },

        async selectArea() {
          this.selectedKind = null;
          this.kindsForSelectedArea = await this.LOAD_KINDS_BY_AREA(this.selectedArea.id);
        },

        cancelKindCreation() {
          this.newKind = {};
          this.selectedKind = null;
          this.displayFormForKind = false;
        },

        async createNewKind()
        {
          let kindAttrs = this.newKind;
          kindAttrs.area_id = this.selectedArea.id;
          let res = await this.CREATE_KIND(
              kindAttrs
          );
          this.kindsForSelectedArea = await this.LOAD_KINDS_BY_AREA(this.selectedArea.id);
          this.selectedKind = this.kindsForSelectedArea.find(x => x.id === res.id);
          this.displayFormForKind = false;
        },

        async createNewStandard()
        {
          let standardAttrs = {
            ...this.newStandard,
            kind_id: this.selectedKind.id,
            kind_code: this.selectedKind.code,
          }
          await this.CREATE_STANDARD(standardAttrs);

          this.selectedKind = await this.LOAD_KIND_BY_ID({
            orkId: this.orkInfo.id,
            kindId: this.selectedKind.id
          });

          // clear new standard
          this.newStandard = {};
        },

        async loadItems() {
            this.data = [...this.qualificationsList];
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },

        async addItems() {
            const params = {
                kind_id: this.kindId,
                qualifications: this.selection.map((item) => item.id)
            }

            if (this.kindId === null) {
              await this.SAVE_KINDS_FROM_QUALIFICATIONS({qualifications: params.qualifications});
            } else {
              await this.SAVE_QUALIFICATIONS(params);
            }

            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.closeDialog();
        },
        createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                // Если модалка открыта вне ВПД, то подставляет ВПД из селекта
                kind_id: this.kindId ?? this.selectedKind.id,
                level: this.entityLevel  
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.CREATE_QUALIFICATION(params).then((qualification) => {
                e.target.reset();

                this.entityLevel = null;
                this.selectedArea = null;
                this.selectedKind = null;

                this.LOAD_KINDS();

                this.data = [...this.qualificationsList];

                if (this.checkedEntity) {
                    this.selection.push(qualification);
                }
            });
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        }
    },
    computed: {
        ...mapState('editor', ['areas', 'groupItemsBy', 'groupKinds', 'lifecycles', 'orkInfo']),
        ...mapState('listsForEditor', ['qualificationsList']),

        filtered() {
            // Фильтруем по поиску
            return !this.searchValue ? this.data : this.data.filter((item) => String(item.code).toLowerCase().includes(this.searchValue.toLowerCase()) || String(item.name).toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        tableData() {
            // Пагинация
            return this.filtered.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },
        filteredData() {
            return this.tableData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    },
    watch: {
        code: function(val) {
            if (!val) this.codeError = true
            else if (val.includes('_')) this.codeError = true
            else this.codeError = false
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>

<style>
  .entity-form__select-creation {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  .entity-form__item_dot {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    background: #4d586f;
    border-radius: 100%;
  }

  .status-dot__success {
    background: #3cb07d;
  }

  .status-dot__danger {
    background: #ce4556;
  }

  .status-dot__warning {
    background: #dd9124;
  }

  .v-select .vs__selected-options {
    width: calc(100% - 24px);
  }

</style>